<template>
  <div class="bottom__counter">
    <span>Wpłaciliście:</span>
    <div v-if="auctionsIncome > 0" class="counter-digits">
        <div
            v-for="(digit, index) in prepareAmountDigits"
            :key="'digit-' + index"
            class="digit"
            :class="'digit-' + index"
        >
            <span>{{ digit }}</span>
        </div>
    </div>
    <span>złotych</span>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        auctionsIncome: 0
      }
    },
    computed: {
      prepareAmountDigits: function() {
        let currentAmount = this.auctionsIncome;
        let splitted = currentAmount.toString().split("");
        let splittedLength = splitted.length;
        return splitted;
      },
    },
    mounted() {
      this.auctionsIncome = window.allegro_auctions_amount
    }
  };
</script>

<style lang="scss" scoped>
.bottom__counter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 40px;

    @media only screen and (max-width: 1160px) {
      flex-direction: column;
    }

    & > span {
      color: #3E4E57;
      font-weight: 700;
      font-size: 18px;
    }
}
.counter-digits {
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media only screen and (max-width: 1160px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .currency {
      font-size: 30px;
      margin-left: 10px;
      font-weight: 600;

      @media only screen and (max-width: 768px) {
          font-size: 16px;
      }
  }

  .digit {
      height: 50px;
      width: 37px;
      font-size: 36px;
      line-height: 50px;
      color: #fff;
      border-radius: 4px;
      text-align: center;
      margin: 0 2px;
      font-weight: 500;
      position: relative;
      z-index: 1;

      // &.digit-0, &.digit-3 {
      //     margin-right: 12px;
      // }

      @media only screen and (max-width: 768px) {
          font-size: 24px;
          line-height: 35px;
          height: 35px;
          width: 24px;

          // &.digit-1, &.digit-4 {
          //     margin-right: 4px;
          // }
      }

      // cień górny
      &:before {
          content: "";
          position: absolute;
          top: -1px;
          left: 0;
          width: 100%;
          height: 10px;
          background: #FF5A00;
          opacity: 0.45;
          border-radius: 4px 4px 0 0;
          z-index: 0;
      }

      // cień dolny
      &:after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 4%;
          width: 93%;
          height: 4%;
          background: #FF5A00;
          opacity: 0.4;
          border-radius: 0 0 4px 4px;
          z-index: -1;
      }

      span {
          position: relative;
          z-index: 1;
          display: block;
          width: 100%;
          background: #FF5A00;
          border-radius: 4px;
          height: 100%;

          // pasek przecinający
      &:before {
          content: "";
          width: 100%;
          height: 1px;
          position: absolute;
          top: 50%;
          left: 0px;
          background: #fff;
          opacity: 0.2;
      }
      }
  }
}
</style>